import axios from 'axios'
import { CHANGE_TICKET_CACHBOX } from './consts'
import { IChangeCashboxResponse } from './ticketsList.types'

export const changeCashbox = (token: string, value: string) => {
  return axios.post<IChangeCashboxResponse>(`${CHANGE_TICKET_CACHBOX}/${token}`, {
    cashBoxId: value,
  })
}
